import { useMutation } from "@tanstack/react-query";
import api from "../../../api";
import { toast } from "react-toastify";
import { toastStyles } from "../../../styles/styles";
import { PAGE_CONFIG } from "../config";

export const useDeleteTimeline = (queryClient, theme, onSuccessCallback) => {

    const { mutate: deleteTimeline, status: deleteStatus, isPending: isDeleting } = useMutation({
        mutationFn: (id) => {
            return api.timeline.deleteTimeline(id);
        },
        onSuccess: (data) => {
            toast.success(data?.message || 'Timeline deleted successfully', { ...toastStyles, theme: theme });
            queryClient.invalidateQueries([PAGE_CONFIG.GET_QUERY_KEY]);
            onSuccessCallback && onSuccessCallback();
        },
        onError: (error) => {
            toast.error(error?.response?.data?.message || 'Timeline deletion failed', { ...toastStyles, theme: theme });
        }
    });

    return { deleteTimeline, isDeleting, deleteStatus };
}